import { createContext } from 'react'

import { StyleContextType } from './types'

const StyleContext = createContext<StyleContextType>({
  style: undefined,
  setLocalStyle: () => {
    // Empty function for default context
  },
  fetchAndSetStyle: () => Promise.resolve(undefined),
  isLoadingStyle: true,
  getFromStorage: () => Promise.resolve(undefined),
})

export { StyleContext }
